<div class="blackBg bgGray d-flex signUpBg">
    <!-- cont_area -->
    <div class="col cont_area">
        <router-outlet></router-outlet>
    </div>
    <!-- cont_area -->
    <img src="assets/images/golf_ball-half_white.svg" alt="" class="btmGolf_img bigGolf">
</div>